import * as React from 'react';
import { followItemsData, profileRecentBidsData } from '../../../../Shared/FackeDataFactory';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import facebook from '../../../../assets/images/Profile/facebook (1).png';
import instagram from '../../../../assets/images/Profile/instagram.png';
import twitch from '../../../../assets/images/Profile/twitch.png';
import discord from '../../../../assets/images/Profile/discord.png';
import twitter from '../../../../assets/images/Profile/twitter.png';
import { allFollowersPeoplesData, followersPeoplesData } from '../../../../Shared/GlobalDataFactory';
import { AnimatePresence, motion } from 'framer-motion';
import useClickOutside from '../../../../Hooks/useClickOutside';
import { NavLink } from 'react-router-dom';



export interface IAppProps {
}

export function ProfilePostRightSide(props: IAppProps) {


    // follow/ Unfollow
    const [isFollow, setIsFollow] = React.useState(false)

    // add new followers modal
    const [showAddFollowersModal, setShowAddFollowersModal] = React.useState(false)
    const addFollowersModalRef = React.useRef<HTMLHeadingElement>(null);
    useClickOutside(addFollowersModalRef, () => setShowAddFollowersModal(false))

    const SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];
    const abbreviateNumber = (number: any) => {
        const tier = Math.log10(Math.abs(number)) / 3 | 0;
        if (tier === 0) return number;
        const suffix = SI_SYMBOL[tier];
        const scale = Math.pow(10, tier * 3);
        const scaled = number / scale;
        return scaled.toFixed(1) + suffix;
    }



    return (
        <div className="xs:hidden md:block xl:ml-16 2xl:ml-52 text-left profile_posts_right_side_section xs:order-1 xl:order-2
        sm:w-full
        xl:w-[432px]
        ">



            <div className="mb-8 relative xs:hidden md:block">
                <div className="inline-block relative">
                    <h1 className="xs:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Followers </h1>
                    <div className="bottom-1 absolute -right-4">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                            <defs>
                                <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                    <stop offset={0} stopColor="#00dbff" />
                                    <stop offset="0.529" stopColor="#e315e8" />
                                    <stop offset={1} stopColor="#ffd817" />
                                </linearGradient>
                            </defs>
                            <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                        </svg>
                    </div>
                </div>



                <div className="grid grid-cols-6 mt-4 justify-start items-center">
                    <div className="child peoples_section_under_wallet flex flex-col justify-center items-center mr-auto">
                        <button className="flex justify-center items-center add_people_btn w-14 h-14 rounded-full"
                            onClick={() => setShowAddFollowersModal(!showAddFollowersModal)}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="#FFFFFF" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                        </button>
                        <p className="text-cusBlack dark:text-cusBlueWhite text-xs mt-2">Add new</p>
                    </div>

                    {followersPeoplesData.map((data, index) =>
                        <div className="child peoples_section_under_wallet flex flex-col justify-center items-center " key={data.id}>

                            <div className="relative group">
                                <NavLink to="/publicProfile/activity">
                                    <button className="flex justify-center items-center w-14 h-14 rounded-full relative">
                                        <div>
                                            <img src={data.photo} alt="" className="w-full h-full" />
                                        </div>
                                        {data.isActive &&
                                            <div className="active_ellips w-5 h-5"></div>
                                        }
                                    </button>
                                </NavLink>

                                <div className="bg-white dark:bg-[#363375] border dark:border-[#2c2a55] rounded-xl bottom-16 left-[-150%]
                                        hidden group-hover:block group-hover:absolute min-w-[220px] transition-all shadow-xl
                                        dark:shadow-[#00000090]"
                                    style={{ zIndex: 99 }}>
                                    <div className="relative p-4">
                                        <div className="flex justify-start items-center">
                                            <NavLink to="/publicProfile/activity">
                                                <motion.div
                                                    whileHover={{ scale: 1.1 }}
                                                    whileTap={{ scale: 0.8 }}
                                                    transition={{ duration: 0.2 }}
                                                    className="w-14 h-14 rounded-full overflow-hidden">
                                                    <div>
                                                        <img src={data.photo} alt="" className="w-full h-full" />
                                                    </div>
                                                </motion.div>
                                            </NavLink>

                                            <div className="ml-3">
                                                <p className="text-cusBlack dark:text-white text-sm lg:text-lg font-bold">{data.name}</p>
                                                <motion.button
                                                    whileTap={{ scale: 0.9 }}
                                                    transition={{ duration: 0.1 }}
                                                    onClick={() => setIsFollow(!isFollow)}
                                                    className="bg-cusLightLink dark:bg-cusBlack text-white dark:text-cusLink px-5 py-1 rounded-md mt-0.5
                                                text-sm">
                                                    {isFollow ? "Follow" : "Unollow"}
                                                </motion.button>
                                            </div>
                                        </div>


                                        <div className="w-[40px] overflow-hidden inline-block absolute -bottom-[20px] left-[45%] ">
                                            <div className="h-[20px] w-[20px] bg-white dark:bg-[#363375] -rotate-45 transform origin-top-left" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <p className="text-cusBlack dark:text-cusBlueWhite text-xs mt-2 text-center">{data.name}</p>
                        </div>
                    )}
                </div>






                <AnimatePresence>
                    {showAddFollowersModal &&
                        <div
                            className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                            <div className="flex items-center justify-center min-h-screen pt-4 px-4 text-center sm:block sm:p-0">
                                <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                                <motion.div
                                    animate={showAddFollowersModal ? "open" : "closed"}
                                    initial={{ scale: 0.7 }}
                                    variants={{
                                        open: { scale: 1 },
                                        closed: { scale: 0.9 },
                                    }}
                                    exit={{ scale: 0 }}
                                    transition={{ duration: 0.1 }}
                                    ref={addFollowersModalRef}
                                    className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                    rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:align-middle
                                    max-w-sm md:max-w-sm w-full h-[80vh] sm:h-[70vh] lg:h-auto pb-14 lg:pb-0">

                                    <div className="flex justify-between items-center px-6 pt-5 pb-4">
                                        <h5 className="text-cusBlack dark:text-white text-2xl font-extrabold">Followers</h5>

                                        <button onClick={() => setShowAddFollowersModal(false)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                                <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            </svg>
                                        </button>
                                    </div>

                                    <div className="pb-6 pl-6 pr-4 flex flex-col h-full lg:max-h-[500px] overflow-y-auto">
                                        {allFollowersPeoplesData.map(people =>
                                            <div key={people.id}
                                                className="flex justify-start items-center w-full mb-4 break-all">
                                                <div className="">
                                                    <div className="w-8 h-9 xsm:w-10 xsm:h-10 md:w-12 md:h-12 rounded-full overflow-hidden">
                                                        <img src={people.photo} alt="" className="w-full" />
                                                    </div>
                                                </div>

                                                <div className="ml-2 xsm:ml-4 flex-1 w-full">
                                                    <h5 className="font-bold w-full text-cusBlack dark:text-white max-w-[90px] xxsm:max-w-[120px]
                                                    sm:max-w-[140px] truncate text-sm md:text-base">{people.name}</h5>

                                                    <p className="text-l-LightBlack dark:text-cusBlueWhite xsm:mt-0.5
                                                    whitespace-nowrap overflow-hidden overflow-ellipsis text-xxs xsm:text-xs md:text-sm">{abbreviateNumber(people.followersNum)} Followers</p>
                                                </div>


                                                <motion.button
                                                    whileHover={{ scale: 1.1 }}
                                                    whileTap={{ scale: 0.9 }}
                                                    transition={{ duration: 0.2 }}
                                                    className="dark:border bg-cusBlack dark:bg-[#363375] dark:border-[#58549c]
                                                    px-2.5 py-1.5 xsm:px-3 xsm:py-2 md:px-6 md:py-2
                                                    rounded-md md:rounded-lg text-white font-semibold text-xxs xxsm:text-xs md:text-sm">
                                                    Add
                                                </motion.button>
                                            </div>
                                        )
                                        }
                                    </div>
                                </motion.div>
                            </div>
                        </div>
                    }
                </AnimatePresence>



            </div>













            <div className="lightBlueBg p-7 rounded-2xl text-left">

                <div className="inline-block relative">
                    <h1 className="xs:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Social</h1>
                    <div className="bottom-1 absolute -right-4">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                            <defs>
                                <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                    <stop offset={0} stopColor="#00dbff" />
                                    <stop offset="0.529" stopColor="#e315e8" />
                                    <stop offset={1} stopColor="#ffd817" />
                                </linearGradient>
                            </defs>
                            <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                        </svg>
                    </div>
                </div>

                <div className="flex justify-start items-center space-x-3 mt-4">
                    <a href="">
                        <img src={discord} alt="" />
                    </a>
                    <a href="">
                        <img src={facebook} alt="" />
                    </a>
                    <a href="">
                        <img src={twitch} alt="" />
                    </a>
                    <a href="">
                        <img src={twitter} alt="" />
                    </a>
                    <a href="">
                        <img src={instagram} alt="" />
                    </a>
                </div>

                <div className="border-b-2 dark:border-gray-900 mt-10 mb-3"></div>


                <div className="flex xs:flex-row xl:flex-col">

                    <div>
                        <div className="inline-block relative xl:mt-3">
                            <h1 className="xs:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Recent Bids</h1>
                            <div className="bottom-1 absolute -right-4">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                                    <defs>
                                        <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                            <stop offset={0} stopColor="#00dbff" />
                                            <stop offset="0.529" stopColor="#e315e8" />
                                            <stop offset={1} stopColor="#ffd817" />
                                        </linearGradient>
                                    </defs>
                                    <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                                </svg>
                            </div>
                        </div>

                        <div>
                            {profileRecentBidsData.map((data, index) =>
                                <div className="grid grid-cols-6 mt-3 justify-center items-center" key={data.id}>
                                    <div className="rounded-full">
                                        <img src={data.photo} alt="" className="w-full h-full" />
                                    </div>

                                    <div className="col-span-5 pl-4">
                                        <div className="flex justify-start items-center">
                                            <h4 className="text-base text-cusBlack dark:text-white mr-2">{data.name}</h4>

                                        </div>
                                        <p className="text-cusBlack dark:text-cusBlueWhite text-xs mt-1">{data.price}</p>
                                    </div>

                                </div>
                            )}
                        </div>
                    </div>


                    <div className="border-b-2 dark:border-gray-900 my-8"></div>

                    <div> <div className="inline-block  relative ">
                        <h1 className="xs:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Follow</h1>
                        <div className="bottom-1 absolute -right-4">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                                <defs>
                                    <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                        <stop offset={0} stopColor="#00dbff" />
                                        <stop offset="0.529" stopColor="#e315e8" />
                                        <stop offset={1} stopColor="#ffd817" />
                                    </linearGradient>
                                </defs>
                                <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                            </svg>
                        </div>
                    </div>


                        <div className="mt-6 mb-3">
                            {followItemsData.map((flData, index) =>
                                <div className="grid grid-cols-6 mt-4 justify-center items-center" key={flData.id}>
                                    <div className="rounded-full">
                                        <img src={flData.logo} alt="" className="w-full h-full" />
                                    </div>

                                    <div className="col-span-3 pl-4">
                                        <div className="flex justify-start items-center">
                                            <h4 className="text-base dark:font-normal font-bold text-cusBlack dark:text-white mr-2">{flData.name}</h4>

                                            {flData.verified &&
                                                <svg xmlns="http://www.w3.org/2000/svg" className="-mb-2"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink" width="35.74" height="35.673" viewBox="0 0 35.74 35.673">
                                                    <defs>
                                                        <filter id="Path_666" x={0} y={0} width="35.74" height="35.673" filterUnits="userSpaceOnUse">
                                                            {/* <feOffset dy={3} input="SourceAlpha" /> */}
                                                            <feGaussianBlur stdDeviation={3} result="blur" />
                                                            <feFlood floodColor="#f08" floodOpacity="0.314" />
                                                            <feComposite operator="in" in2="blur" />
                                                            <feComposite in="SourceGraphic" />
                                                        </filter>
                                                    </defs>
                                                    <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_666)">
                                                        <path id="Path_666-2" data-name="Path 666" d="M631.76,279.583s7.714-1.937,14.928,0a34.6,34.6,0,0,1-.067,14.794,34.923,34.923,0,0,1-14.894.033S629.856,286.462,631.76,279.583Z" transform="translate(-621.3 -272.11)" fill="#ff0091" stroke="#c90072" strokeMiterlimit={10} strokeWidth={1} />
                                                    </g>
                                                    <image id="Image_44" data-name="Image 44" width={11} height={11} transform="translate(12.31 9.303)" xlinkHref="data:image/png;base64,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" />
                                                </svg>
                                            }
                                        </div>
                                        <p className="text-cusBlack dark:text-cusBlueWhite text-xs mt-1">{flData.designation}</p>
                                    </div>

                                    <motion.div
                                        whileTap={{ scale: 0.9 }}
                                        transition={{ duration: 0.1 }}
                                        className="col-span-2">
                                        <button className="text-sm text-gray-500 dark:font-normal
                                border dark:border-[#58549c] border-[#EFEFEF] hover:bg-[#d6d6d6] dark:hover:bg-[#58549c]
                                font-bold dark:text-white rounded-lg w-full py-2.5 transition-all bg-[#EFEFEF] dark:bg-[#363375]">
                                            {flData.follow ? "Follow" : "Connect"}
                                        </button>
                                    </motion.div>

                                </div>
                            )}
                        </div>
                    </div>

                </div>






            </div>








        </div>
    );
}
